// <%= vite_javascript_tag 'turbo' %>

// Reuse the existing ActionCable consumer so Turbo doesn't create its own,
// preventing multiple WebSocket connections.
import { Turbo, cable } from "@hotwired/turbo-rails";
import consumer from "../src/channels/consumer";
import { patchTurboFragmentNavigation } from "../src/utils/turboFragmentNavigation";
import { installTurboFrameMovePreservation } from "../src/hotwire/turboFrameMovePreservation";

cable.setConsumer(consumer);

// Custom element slot projection moves slotted frames instead of re-creating them;
// keep their in-flight requests alive during those moves.
if (!installTurboFrameMovePreservation()) {
  console.warn("[easy8 turbo] turbo-frame move preservation not installed; slotted frames reload when projected");
}

// Keep fragment navigation (`href="#"`, `location.hash = …`) from firing `turbo:before-cache`, which tears
// Intercom down for good. Refs #694109.
patchTurboFragmentNavigation(Turbo.session);
